<div class="orders column-left gap-8">
    <h3 class="title">Generar orden</h3>

    <div class="container-orders width-100">
        <app-button-order class="button" id="desde-tablero" text="Desde Tablero" image="desde-tablero" (click)="goToPriceBoard()"></app-button-order>
        <app-button-order class="button" id="manual" text="Manual" image="manual" (click)="goToGenerateOrderManual()"></app-button-order>
    </div>
</div>